import React, { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router';

import { EntityDeletedMessageContainer } from './EntityDeletedMessage.container';
import { PipeContainer } from '../subscription/pages/pipes/Pipe.container';

import type { RootState } from '../types/state.types';

export const PipeDeletedContainer: React.FC<PropsWithChildren<RouteComponentProps<{}, any>>> = (
  props
) => {
  const { subId, pipeID } = props.params;
  const deletedPipes = useSelector((state: RootState) => state.liveUpdates.deletedPipes);
  const isDeleted = deletedPipes.some((pId) => pId === pipeID);
  const isDirty = useSelector((state: RootState) => state.editor.isDirty);
  const unsavedEditedConfig = useSelector((state: RootState) => state.editor.unsavedEditedConfig);

  if (isDeleted) {
    return (
      <EntityDeletedMessageContainer
        pipeId={pipeID}
        gotoLink={`/subscription/${subId}/pipes/all`}
        config={isDirty ? unsavedEditedConfig : undefined}
        entityName="pipe"
      />
    );
  }

  return <PipeContainer {...props} />;
};
